import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getDressingAsync, getlistOptionsAsync, saveDressingAsync, setTreatmentViewData } from "../../../../../app/patientSlice";

export const useTreatmentBase = ({ interventionId, formularyId, payType, listOptionsSelector, getDataSelector }) => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();

  const listOptions = useSelector(listOptionsSelector);
  const getData = useSelector(getDataSelector);

  useEffect(() => {
    if (formularyId !== null) {
      dispatch(
        getlistOptionsAsync({
          formularyid: formularyId,
          option: payType,
          payType,
        })
      );
      dispatch(getDressingAsync({ patientId, assessmentId, interventionId, payType }));
    }
  }, [assessmentId, dispatch, formularyId, interventionId, patientId, payType]);

  useEffect(() => {
    dispatch(setTreatmentViewData([]));
  }, [dispatch]);

  const doSubmit = useCallback(
    (data) => {
      dispatch(
        saveDressingAsync({
          productCategory: data,
          patientId,
          assessmentId,
          interventionId,
          payType,
        })
      );
    },
    [dispatch, patientId, assessmentId, interventionId, payType]
  );

  return {
    editData: listOptions ?? [],
    viewData: getData ?? [],
    doSubmit,
  };
};
